import {useDispatch, useSelector} from "react-redux";
import {RootStore} from "../../../../store/Store";
import {useEffect} from "react";
import {getAllMedicareStaffMembers} from "../../../../store/staffList/actions/StaffListActions";
import {useRouteSetup} from "../../Hooks/useRouteSetup";
import {useUserData} from "../../../Hooks/useUserData";
import useMcConfig from "../../../Hooks/useMcConfig";

export function useAbsenceCalendar() {
    const {config} = useMcConfig();
    const absenceCalendarStore = useSelector((state: RootStore) => state.absenceCalendar);
    const dispatch = useDispatch();
    const user = useUserData();
    const {setRoutes} = useRouteSetup();

    useEffect(() => {
        dispatch(getAllMedicareStaffMembers());
    }, []);

    useEffect(() => {
        if (!config.auth) return;
        if (user.username.length === 0) return;
        setRoutes(user, config);
    }, [user, config]);

    return {
        absenceCalendarStore
    };
}
